import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import MyApi from '../../api/MyApi'

class Footer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      status: false,
      message: "",
      footerData: {
        id: "",
        imagePath: "",
        email: "",
        tel: "",
        time: "",
        address: "",
        copyright: "",
        zipCode: ""
      }
    }
  }

  initData() {
    // let res = {"c_footer":[{"zipCode":"１３５‐００１６","copyright":"Copyright SUN FLOWER SOFT 株式会社 Co. Ltd. All Rights Reserved.","address":"東京都江東区東陽3-23-26 東陽町コーポラス 3F-19号室","imagePath":"/res/static/img/erweima.png","tel":"03-5632-6432","id":"1","time":"9:00-18:00","email":"info@sunflower-soft.com"}],"message":"请求数据成功","status":true}
    let res = { "c_footer": [{ "zipCode": "101-0041", "copyright": "ALL RIGHTS RESERVE 2019 BY SHUOLEI GROUP.", "address": "東京都千代田区神田須田町1-28-4 日宝神田ビル10階", "imagePath": "/res/static/img/erweima.png", "imagePath2": "/res/static/img/Pmark.png","tel": "03-3525-8872", "fax": "03-3525-8713", "id": "1", "time": "9:00-18:00", "email": "info@sunflower-soft.com" }], "message": "请求数据成功", "status": true }
    res.footerData = res.c_footer[0];
    delete res.c_footer
    this.setState(res)
    // MyApi.queryAllApi('post','queryAllApi','c_footer').then((res) => {
    //   res.footerData = res.c_footer[0];
    //   delete res.c_footer
    //   this.setState(res)
    // })

  }

  componentDidMount() {
    this.initData();
  }
  render() {

    return (
      <div className="layui-row">
        <div className="footer">
          <div className="layui-container">
            <div className="layui-row footer-contact">

              {/* 第1列：左侧图片（独立） */}
              <div className="layui-col-sm1 layui-lg1 ftImgErweima">
                <img class="erweima" src={this.state.footerData.imagePath} alt="" />
              </div>

              {/* 第2列：企业情報（独立） */}
              <div className="layui-col-sm5 layui-lg5 ftInformation">
                <p className="select"><span>&emsp;企業情報</span></p><hr />
                <p className="contact"><span><Link to="/history">会社概要</Link></span></p>
                <p className="contact"><span><Link to="/cases">関連会社</Link></span></p>
                <p className="contact"><span><Link to="/about">募集情報</Link></span></p>
                <p className="contact"><span><Link to="/privacyPolicy">個人情報保護方針</Link></span></p>
                <p className="contact"><span><Link to="/contact">お問い合わせ</Link></span></p>
              </div>

              {/* 第3列：联系方式（独立） */}
              <div className="layui-col-sm5 layui-lg5 ftContact">
                <p className="contact-top"><span><i className="layui-icon">&#xe678;</i>&nbsp;&nbsp;{this.state.footerData.tel}</span></p>
                <p className="contact-top"><span><i className="layui-icon">&#xe66d;</i>&nbsp;&nbsp;{this.state.footerData.fax}</span></p>
                <p className="contact"><span><strong className="select">〒</strong>&nbsp;&nbsp;{this.state.footerData.zipCode}</span></p>
                <p className="contact"><span><i className="layui-icon">&#xe68e;</i>&nbsp;&nbsp;{this.state.footerData.address}</span></p>
                <p className="contact-bottom"><span><i className="layui-icon">&#xe609;</i>&nbsp;&nbsp;{this.state.footerData.email}</span></p>
              </div>

              {/* 第4列：右侧图片（独立） */}
              <div className="layui-col-sm1 layui-lg1 ftImgPmark">
                <a href="https://privacymark.jp/" target="_blank" rel="noopener">
                <img class="pmark" src={this.state.footerData.imagePath2} alt="" />
                </a>
              </div>

            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Footer
